module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video_bg_4-73b771682c73f6d3a77c8b287f355753.svg";